import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import MobileHeader from '../../components/MobileHeader';
import MobileUserProfile from '../../containers/MobileUserProfile';
import mobileBridge from '../../helpers/MobileBridge';
import dataModel from '../../models/DataModel';

import '../MobileWrapper.scss';

export class UserProfileWrapper extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      user: null,
      headerText: '',
      hasLogoutButton: true,
    };
    this.handleNavigateBack = this.handleNavigateBack.bind(this);
  }

  componentDidMount() {
    mobileBridge.initialize(this.props.history);

    const { currentUser } = this.props;
    const { params, path } = this.props.match;

    if (params.user_id) {
      // generic user profile page
      dataModel.usersDAO.getUser(params.user_id).then(user => {
        this.setState({ user, headerText: (user.first_name + ' ' + user.last_name) });
      });
      this.setState({ hasLogoutButton: false });
    }
    else if (path.includes('my-profile')) {
      // 'my profile' page
      this.setState({ user: currentUser, headerText: 'My Profile' });
      this.setState({ hasLogoutButton: true });
    }
  }

  handleNavigateBack() {
    this.props.history.goBack();
  }

  render() {
    const { headerText, user } = this.state;

    return (
      <div className='mobile-wrapper'>
        <MobileHeader
          headerTitle={headerText}
          handleClear={this.handleClear}
          navigateBack={this.handleNavigateBack}
        />
        <div className="content-wrapper">
          <MobileUserProfile user={user} hasLogoutButton={this.state.hasLogoutButton} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.new_users.currentUser,
  };
};

export default withRouter(connect(mapStateToProps)(UserProfileWrapper));



// WEBPACK FOOTER //
// ./src/mobileWrappers/UserProfileWrapper/index.js